import styled from 'styled-components';

import {
  SelectField,
  SelectIdField,
  TextareaField,
  TextField,
  EmailField,
  CheckboxField,
  DateField,
  SpaceSelectField,
  PhoneField,
  ParagraphField,
} from '~fields';

import { useOfficeOptions, useCostCenterOptions } from '~hooks';

import { getBuildings } from '../formik/components/SpaceSelect/utils';

const TypeDependentFields = ({ type, values, setFieldValue }) => {
  const officeOptions = useOfficeOptions();
  const costCenterOptions = useCostCenterOptions({
    useId: true,
    formatLabel: costCenter =>
      `${costCenter.costCentre} ${costCenter.costCentreTitle}`,
  });

  const getBuildingOptions = async text => {
    const buildings = await getBuildings({ value: values.newRoomOffice }, text);
    const formattedBuildings = buildings.map(building => ({
      value: building.buildingId,
      label: building.label,
    }));

    return formattedBuildings;
  };

  const handleRoomChange = () => {
    setFieldValue('newRoomBuilding', null);
  };

  switch (type) {
    case 'NEW_ROOM':
      return (
        <>
          <CheckboxField name="newRoomPermission" required />

          <ParagraphField name="newRoomInfoParagraph" />

          <HalfWidth>
            <SelectIdField
              name="newRoomOffice"
              options={officeOptions}
              onChange={handleRoomChange}
              fallbackPlaceholder="Valitse..."
            />
            <SelectField
              async
              key={values.newRoomOffice}
              name="newRoomBuilding"
              loadOptions={getBuildingOptions}
              defaultOptions
              fallbackPlaceholder="Valitse..."
              disabled={!values.newRoomOffice}
            />
          </HalfWidth>

          <HalfWidth>
            <SelectIdField name="newRoomUsage" required />
          </HalfWidth>

          <TextareaField name="newRoomDescription" required />

          <HalfWidth>
            <SelectIdField
              name="newRoomCostCenter"
              options={costCenterOptions}
              fallbackPlaceholder="Valitse..."
              // disabled={!room || !locationOptions.length}
              required
            />
          </HalfWidth>

          <HalfWidth>
            <CheckboxField name="newRoomParking" />
            <CheckboxField name="newRoomAccessibility" />
          </HalfWidth>

          <TextareaField name="newRoomAdditionalInfo" required />

          <HalfWidth>
            <EmailField name="newRoomEmail" required />
            <PhoneField name="newRoomPhone" required />
          </HalfWidth>

          <HalfWidth>
            <DateField name="newRoomDate" required />
          </HalfWidth>
        </>
      );
    case 'CHANGE_ROOM':
      return (
        <>
          <CheckboxField name="changeRoomPermission" required />

          <ParagraphField name="changeRoomInfoParagraph" />

          <SpaceSelectField
            name="changeRoomSpace"
            onlyBuilding
            disableCollapse
            required
          />

          <HalfWidth>
            <SelectIdField name="changeRoomUsage" required />
          </HalfWidth>

          <TextareaField name="changeRoomDescription" required />

          <CheckboxField name="changeRoomCostCenterChange" />
          {values.changeRoomCostCenterChange && (
            <SelectIdField
              name="changeRoomNewCostCenter"
              options={costCenterOptions}
              fallbackPlaceholder="Valitse..."
              required
            />
          )}

          <HalfWidth>
            <CheckboxField name="changeRoomParking" />
            <CheckboxField name="changeRoomAccessibility" />
          </HalfWidth>

          <TextareaField name="changeRoomAdditionalInfo" required />

          <HalfWidth>
            <EmailField name="changeRoomEmail" required />
            <PhoneField name="changeRoomPhone" required />
          </HalfWidth>

          <HalfWidth>
            <DateField name="changeRoomDate" required />
          </HalfWidth>
        </>
      );
    case 'CHANGE_PAYER':
      return (
        <>
          <ParagraphField name="changePayerInfoParagraph" />

          <SpaceSelectField
            name="changePayerSpace"
            onlyBuilding
            disableCollapse
            required
          />

          <HalfWidth>
            <SelectIdField
              name="changePayerNewCostCenter"
              options={costCenterOptions}
              fallbackPlaceholder="Valitse..."
              required
            />
          </HalfWidth>

          <TextareaField name="changePayerDescription" required />

          <HalfWidth>
            <EmailField name="changePayerEmail" required />
            <PhoneField name="changePayerPhone" required />
          </HalfWidth>

          <HalfWidth>
            <DateField name="changePayerDate" required />
          </HalfWidth>
        </>
      );
    case 'TERMINATION':
      return (
        <>
          <CheckboxField name="terminatePermission" required />

          <ParagraphField name="terminateInfoParagraph" />

          <SpaceSelectField
            name="terminateSpace"
            onlyBuilding
            disableCollapse
            required
          />

          <TextareaField name="terminateDescription" required />

          <TextField name="terminateAdditionalInfo" fullWidth />

          <HalfWidth>
            <EmailField name="terminatePayerEmail" required />
            <PhoneField name="terminatePayerPhone" required />
          </HalfWidth>

          <HalfWidth>
            <DateField name="terminatePayerDate" required />
          </HalfWidth>

          <CheckboxField name="terminatePayerAcceptance" required />
        </>
      );
    default:
      return null;
  }
};

const HalfWidth = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  & > div {
    flex-basis: 100%;
    max-width: 50%;
  }
`;

export default TypeDependentFields;
